var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AfterViewInit, ElementRef, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environmentOm } from '../../../../environment-om';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class MunicipalityAssetDraftTipReportComponent {
    constructor(reportHelper, reportsApi, route, titleService) {
        this.reportHelper = reportHelper;
        this.reportsApi = reportsApi;
        this.route = route;
        this.reportData = null;
        this.isGenerating = true;
        this.isLoadingMap = false;
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        this.municipalName = '';
        this.countyName = '';
        this.defaultBasemap = {
            tileUrl: environmentOm.basemapURL + '/rest/services/basemaps/penndotbasemap/MapServer/tile',
            thumbnailTile: '/7/48/36',
            tileTemplate: '/{level}/{row}/{col}',
            title: 'PennDOT'
        };
        titleService.setTitle(titleService.getTitle() + ' : Municipality Asset Draft TIP Report');
    }
    ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            const params = JSON.parse(window.localStorage.getItem(x.get('id')));
            const splitIndex = 2;
            this.countyMunicipalityCode = params.countyMunicipalityCode;
            this.countyCode = this.countyMunicipalityCode.substring(0, splitIndex);
            this.municipalCode = this.countyMunicipalityCode.substring(splitIndex);
            this.loadReport();
            this.isGenerating = false;
        });
    }
    ngAfterViewInit() {
        this.loadMap();
    }
    loadReport() {
        return __awaiter(this, void 0, void 0, function* () {
            this.reportsApi.getMunicipalityAssetDraftTipReportData(this.countyCode, this.municipalCode).then((reportData) => __awaiter(this, void 0, void 0, function* () {
                this.reportData = reportData;
                yield this.getMunicipalName();
                yield this.getCountyName();
            }));
        });
    }
    getMunicipalName() {
        return __awaiter(this, void 0, void 0, function* () {
            this.municipalName = yield this.reportHelper.getMunicipalNameFromId([this.countyCode], this.municipalCode);
        });
    }
    getCountyName() {
        return __awaiter(this, void 0, void 0, function* () {
            this.countyName = yield this.reportHelper.getCountyNameFromId(this.countyCode);
        });
    }
    loadMap() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoadingMap = true;
            this.reportHelper.getLayerIdByName('MPMS - TIP - All').then((result) => __awaiter(this, void 0, void 0, function* () {
                const layerId = result[0].id;
                const symbols = this.reportHelper.getBoundaryLayerProperties(this.mapRef.nativeElement.LayerService.legendService);
                try {
                    yield this.mapRef.nativeElement.ready;
                    yield this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
                    const layerSettings = [{
                            id: parseInt(layerId, 10),
                            query: {
                                operator: 'AND', subqueries: [
                                    { field: 'cty_code', operator: '=', value: this.countyCode },
                                    { field: 'municipality_codes', operator: 'INCLUDES', value: this.municipalCode },
                                    { field: 'tip_proposed_flag', operator: '=', value: 'Y' }
                                ]
                            }
                        },
                        {
                            id: environmentOm.layers.filter(x => x.name === 'municipality')[0].id,
                            query: {
                                operator: 'AND', subqueries: [
                                    { field: 'county', operator: '=', value: this.countyCode },
                                    { field: 'municipal_code', operator: '=', value: this.municipalCode }
                                ]
                            },
                            opacity: 0.5,
                            symbols,
                            zoomToLayer: true,
                            generateNewLayer: true
                        }];
                    this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap([...layerSettings].reverse());
                    this.isLoadingMap = false;
                }
                catch (error) {
                    this.isLoadingMap = false;
                }
            }));
        });
    }
}
